import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { API, UPLOADS } from "../../config/api";
export default function AdminHeader() {
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState(null);
  const dropdownRef = useRef();

  useEffect(() => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));

    if (!loginUser?.id) return;

    fetch(`${API.GET_USER}&id=${loginUser.id}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setUser(data.user);
        } else {
          setUser(loginUser);
        }
      })
      .catch((err) => {
        console.error(err);
        setUser(loginUser);
      });
  }, []);
  const toggleSidebar = () => {
    if (window.innerWidth <= 768) {
      document.body.classList.toggle("admin-sidebar-open");
    } else {
      document.body.classList.toggle("admin-sidebar-collapsed");
    }
  };

  const toggleDropdown = () => {
    setOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="admin-hdr">
      {/* LEFT */}
      <div className="admin-hdr-left">
        {/* <button className="admin-hdr-toggle" onClick={toggleSidebar}>
          <i className="bi bi-list"></i>
        </button> */}
        <button
          className="admin-hdr-toggle"
          onClick={() => document.body.classList.add("sidebar-open")}
        >
          <i className="bi bi-list"></i>
        </button>
        <img
          src="/logo.png"
          alt="Embroidery Bazar"
          style={{ height: "55px", objectFit: "contain" }}
        />
        <h4 className="admin-hdr-title">Admin Dashboard</h4>
      </div>

      {/* RIGHT */}
      <div className="admin-hdr-right" ref={dropdownRef}>
        <div className="user-hdr-user" onClick={toggleDropdown}>
          <div className="user-avatar">
            {user?.profile_image ? (
              <img
                src={`${UPLOADS.PROFILE_IMAGE}${user.profile_image}`}
                alt={user.name}
                className="user-avatar-img"
              />
            ) : user?.name ? (
              user.name.charAt(0).toUpperCase()
            ) : (
              <i className="bi bi-person-fill"></i>
            )}
          </div>

          <div className="user-info">
            {/* <small>Welcome Back</small> */}
            <span>{user?.name || "Guest"}</span>
          </div>

          <i className="bi bi-chevron-down"></i>
        </div>

        {open && (
          <div className="admin-hdr-dropdown">
            <Link to="/admin/profile">
              <i className="bi bi-person"></i>
              Profile
            </Link>

            <Link to="/admin/change-password">
              <i className="bi bi-lock"></i>
              Change Password
            </Link>

            <Link to="/admin/logout">
              <i className="bi bi-box-arrow-right"></i>
              Logout
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
